import BigNumber from 'bignumber.js';
import formatDecimal, { isValidDecimal } from '@paradigm/utils/formatDecimal';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';
import * as LegFunctions from '@paradigm/features/src/unified-rfqs/ui/rfqs/legs-functions';
import { getProduct } from '#/products/domain';
import { BaseRfqLeg } from '#/unified-rfqs/entities/shared';
import { LegTableView } from '../types';

export function processProductData(product_code: string) {
  const product = getProduct(product_code);
  const [label = ''] = product.shortName.split('-');
  const { currency } = product;
  return {
    label,
    currency,
  };
}

function clearingUnitiesQuantityView(leg: {
  product_code: string;
  quantity: string;
}): string {
  const product = getProduct(leg.product_code);
  const currencyQty = formatDecimal(leg.quantity);
  return `${currencyQty} ${product.contractCurrency}`;
}

function contractTermsQuantityView(leg: {
  quantity: string;
  product_code: string;
}): string {
  const product = getProduct(leg.product_code);
  const currencyCts = BigNumber(leg.quantity)
    .dividedBy(product.contractSize)
    .toString();
  const currencyQty = formatDecimal(currencyCts);
  return `${currencyQty} Cts`;
}

export interface LegsTableItem extends Omit<BaseRfqLeg, 'ratio'> {
  readonly instrument_name: string;
  readonly quantity: string;
  readonly ratio?: string;
}

export function processLeg(leg: LegsTableItem, index: number): LegTableView {
  const { instrument_name, ratio, side, product_code, price } = leg;
  const product = processProductData(product_code);
  const clearingUnitiesQuantity = clearingUnitiesQuantityView(leg);
  const contractTermsQuantity = contractTermsQuantityView(leg);
  const { contractCurrency } = getProduct(product_code);
  const { expiry, strike, instrumentLabel } =
    LegFunctions.parseInstrument(instrument_name);

  return {
    side,
    ratio: ratio ?? '1',
    index,
    expiry,
    instrument_name,
    clearingUnitiesQuantity,
    contractTermsQuantity,
    quantity: isValidDecimal(leg.quantity)
      ? formatDecimal(leg.quantity)
      : NEGATIVE_SIGN,
    instrumentLabel,
    rowNumber: index + 1,
    productLabel: product.label,
    productCurrency: product.currency,
    contractCurrency,
    strike: strike != null ? formatDecimal(strike) : NEGATIVE_SIGN,
    price: price != null ? formatDecimal(price) : NEGATIVE_SIGN,
  };
}
